export default __webpack_public_path__ + "static/media/graph.d9221ccc.svg";